module.exports = __webpack_public_path__ + "assets/img/level1.6518d188.png";